import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";

type CB = { onSuccess?: (r: any) => void; onError?: (e: any) => void };

export const useVehicleList = (cid: number, params: any = {}) =>
  useQuery({
    queryKey: [API_ENDPOINTS.CV_LIST(cid), params],
    queryFn: () => client.get(API_ENDPOINTS.CV_LIST(cid), { params }),
    select: (r: any) => ({ data: r.data.data as any[], total: r.data.extra?.total ?? 0 }),
    enabled: !!cid,
    refetchOnWindowFocus: false,
  });

export const useVehicleCreate = (cid: number, cb: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => client.post(API_ENDPOINTS.CV_CREATE(cid), data),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.CV_LIST(cid)] }); cb.onSuccess?.(r); },
    onError: cb.onError,
  });
};

export const useVehicleUpdate = (cid: number, cb: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => client.post(API_ENDPOINTS.CV_UPDATE(cid), data),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.CV_LIST(cid)] }); cb.onSuccess?.(r); },
    onError: cb.onError,
  });
};

export const useVehicleDelete = (cid: number, cb: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => client.post(API_ENDPOINTS.CV_DELETE(cid), { id }),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.CV_LIST(cid)] }); cb.onSuccess?.(r); },
    onError: cb.onError,
  });
};

export const useDefectList = (cid: number, params: any = {}) =>
  useQuery({
    queryKey: [API_ENDPOINTS.CV_DEFECTS(cid), params],
    queryFn: () => client.get(API_ENDPOINTS.CV_DEFECTS(cid), { params }),
    select: (r: any) => r.data.data as any[],
    enabled: !!cid,
    refetchOnWindowFocus: false,
  });

export const useDefectResolve = (cid: number, cb: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => client.post(API_ENDPOINTS.CV_DEFECT_RESOLVE(cid), { id }),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.CV_DEFECTS(cid)] }); cb.onSuccess?.(r); },
    onError: cb.onError,
  });
};

export const useMileageList = (cid: number, params: any = {}) =>
  useQuery({
    queryKey: [API_ENDPOINTS.CV_MILEAGE(cid), params],
    queryFn: () => client.get(API_ENDPOINTS.CV_MILEAGE(cid), { params }),
    select: (r: any) => ({ data: r.data.data as any[], total: r.data.extra?.total ?? 0 }),
    enabled: !!cid,
    refetchOnWindowFocus: false,
  });

export const useMileageCreate = (cid: number, cb: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => client.post(API_ENDPOINTS.CV_MILEAGE_CREATE(cid), data),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.CV_MILEAGE(cid)] }); cb.onSuccess?.(r); },
    onError: cb.onError,
  });
};
